module.exports = __webpack_public_path__ + "img/technology.66167b71.jpg";